var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "toast",
    on: {
      "click": _vm.manualHideHandler
    }
  }, [_c('div', {
    staticClass: "toast-dialog"
  }, [_vm._t("content", function () {
    return [_c('div', {
      staticClass: "toast-content"
    }, [_vm._v(_vm._s(_vm.message))])];
  })], 2)]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };